export default __webpack_public_path__ + "static/media/amazon-clone.e839d183.png";